import { AccountingEntryNumberModeEnum } from '~modules/connectors/modules/load/common/services/accounting-number-mode.service';
import { LetteringScopeEnum } from '~modules/connectors/modules/load/common/services/lettering-scope.service';
import { FileDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

export const traDownLoadFieldsConfiguration : FileDownloadFieldsConfiguration = {
    toolLabel: 'tra_dl',
    generatePartialLettering: {
        defaultValue: false,
        visible: false
    },
    accountingEntryNumberMode: {
        visible: false,
        defaultValue: AccountingEntryNumberModeEnum.NONE
    },
    removeSpecialCharacters: {
        visible: true,
        defaultValue: false
    },
    letteringScope: {
        defaultValue: LetteringScopeEnum.BY_ACCOUNT,
        visible: false
    }
}